import React from 'react';
import { Card, Alert, Empty } from 'antd';

interface ListingTradingStepProps {
  module: string | null;
  projectCode: string;
}

const ListingTradingStep: React.FC<ListingTradingStepProps> = ({
  module,
  projectCode,
}) => {
  if (!module) {
    return (
      <Alert
        message="请选择要操作的上市交易模块"
        description="请从左侧导航中选择具体的交易模块"
        type="info"
        showIcon
      />
    );
  }

  return (
    <Card title={`上市交易 - ${module}`}>
      <Alert
        message="暂无内容"
        description={`模块 "${module}" 暂无可用内容`}
        type="info"
        showIcon
      />
    </Card>
  );
};

export default ListingTradingStep;
